export const frontmatter = {
  title: "Tokenomics",
  order: 5,
}

## SCALE

The token's basic liquid form is the SCALE token. This token will be used as a liquid, transferable token for emissions and can be locked into a veNFT.

## veSCALE

SCALE can be locked in the form of veSCALE into an NFT which adopts the vote escrow model for obtaining fees and directing emissions. Various lock periods can be selected, and the veNFT is a transferable asset.

## No Rebase

Some of you might be familiar with the rebase model that incentivizes early adopters of the SOLIDLY platform. We have decided to completely remove this model as it presents a problem for new entrants, as they find it hard to obtain a fair ownership percentage of fees and voting power later in the evolution of the exchange.

## veLOCK Period

Our lock period will be a maximum of 26 weeks, and the percentage of your lock time will be issued to your veSCALE. This modifier will give you your voting power and percentage of fees in the pool you select.

## Token Distribution

![image](https://miro.medium.com/v2/resize:fit:828/format:webp/1*kCAZm_OXKI8jxuwdrn2aAQ.png)

## Initial Token Supply

The initial token supply will be dispersed as per the chart above.

- 40% veSCALE airdropped to all of our holders from Fantom (4,000,000)
- 25% veSCALE Ecosystem Pair NFTs (2,500,000)
- 15% veSCALE Team NFTs (1,500,000)
- 10% SCALE initial liquidity (1,000,000)
- 10% SCALE incentives (1,000,000)

## Airdrop Breakdown

In order to include each and every loyal Equalizer supporter from Fantom, we have decided on the following point system:

| Activity                         | Points                          |
| -------------------------------- | ------------------------------- |
| veEqual holders                  | 100 points per veEqual token    |
| Liquidity Providers on Equalizer | 50 points per Equal token in LP |
| Liquidity Providers on Tarot     | 40 points per Equal token in LP |
| Tarot Lenders                    | 5 points per Equal token        |
| Liquid Equal holder              | 2 points per Equal token        |

_\*Minimum 1337 points required_

\*\* For fairness and to prevent gaming of the system, we took a snapshot at the time of releasing our launch details on Medium, on Sep 8th 2023 @ 15:25:03 GMT, Fantom Block Height: 67,980,758.

Check out our [Dune Dashboard](https://dune.com/equal/scale-airdrop) for complete details about the airdrop.

Airdrop claim page: [airdrop.equalizer.exchange](https://airdrop.equalizer.exchange/)

Airdrop claim window will remain available indefinitely.

### Future interactions & rewards

For future **veEQUAL lockers** on FTM, we've set aside a special allocation of 400,000 tokens. This is to acknowledge the continued support and commitment of our community, ensuring that future interactions and locks are also considered for reward.

## Weekly Emissions

Emissions will start at 400,000 SCALE per week and decline at 2% per week.

- Week 1–400,000
- Week 2–392,000
- Week 3–384,160
- Week 4–376,476
- Week 5–368,947

The decay factor will be re-evaluated after every 10 epochs.

From week 104, the decline rate will reset to 0.1%.

This will provide a slow & predictable decline in emissions that will last into the next century.

_This page was last updated on October 20th 2023._
